<div class="bid-group" *ngFor="let group of bidGroups" [class.active]="group.isActive">
	<div class="bid-group-description">{{ group.description }}</div>
	<div class="bid-group-option" *ngFor="let option of group.options">
		<div class="bid-group-option-description">{{ option.description }}</div>
		<div class="bid-group-option-amount">{{ formatOptionAmount(option) }}</div>
	</div>
</div>
